import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../front-end-global-components/components/Button/Button";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import { abdmResetAbhaPassword } from "../../redux/patients/actions";
import { validation } from "../../utils/validators";

function ResetPassword(props) {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: ""
  });
  const navigate = useNavigate();

  return (
    <>
      <Header
        supportIconOnClick={() => {
          navigate("/query");
        }}
        title={"Reset Password"}
        backButtonOnClick={() => {
          navigate("/settings");
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />
      <section className="remaining-body-height margin-horizontal-auto padding-right-larger padding-left-larger overflow-y-auto inherit-parent-width ">
        {!props.app.featureFlags?.abhaService && <FeatureFlagsFallback />}

        {props.app.featureFlags?.abhaService && (
          <form
            className=" flex-direction-column max-width-588px inherit-parent-height flex-justify-content-space-between"
            onChange={(event) => {
              setFormData({
                ...formData,
                [event.target.name]: event.target.value
              });
            }}
            onSubmit={(event) => {
              event.preventDefault();
              if (formData?.password) {
                abdmResetAbhaPassword(formData?.password, navigate);
              }
            }}
          >
            <div>
              <div className="text-align-center padding-top-larger font-color-secondary">
                RESET PASSWORD
              </div>

              <InputBox
                className="inherit-parent-width border-radius-default margin-top-larger margin-bottom-default"
                name="password"
                label="Password *"
                type="password"
                value={formData.password}
                validation={(value) => validation("password", value)}
                data-cy="NEW-PASSWORD"
                required
              />
              <InputBox
                className="inherit-parent-width border-radius-default margin-bottom-default"
                name="confirmPassword"
                label="Confirm Password *"
                type="password"
                validation={(value) => {
                  if (!(value === formData.password)) {
                    return {
                      status: false,
                      message: "Password does not match"
                    };
                  }
                }}
                value={formData.confirmPassword}
                data-cy="CONFIRM-PASSWORD"
                required
              />
            </div>
            <div>
              <Button
                text="Save"
                data-cy="SAVE-BUTTON"
                boxShadow={false}
                className="margin-top-large margin-bottom-larger"
                type="submit"
                disabled={
                  formData.password &&
                  formData.confirmPassword &&
                  validation("password", formData.password).status &&
                  formData.password === formData.confirmPassword
                    ? false
                    : true
                }
                loading={props.patients.loading}
              />
            </div>
          </form>
        )}
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(ResetPassword);
